import { render, staticRenderFns } from "./WokIconCheckC64.vue?vue&type=template&id=6c2713b2&functional=true&"
import script from "./WokIconCheckC64.vue?vue&type=script&lang=ts&"
export * from "./WokIconCheckC64.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports